import { normalizeBadgeIcon } from "../../lib/leetcode";
import LazyImage from "./LazyImage";

const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString(undefined, { month: "short", year: "numeric" });
};

// A single LeetCode badge tile (icon + name + earned date).
const LeetCodeBadge = ({ badge }) => (
  <div className="lc-badge" title={badge.displayName}>
    <div className="lc-badge-icon">
      <LazyImage src={normalizeBadgeIcon(badge.icon)} alt={badge.displayName} />
    </div>
    <span className="lc-badge-name">{badge.displayName}</span>
    {badge.creationDate && (
      <span className="lc-badge-date">{formatDate(badge.creationDate)}</span>
    )}
  </div>
);

export default LeetCodeBadge;
